import { Dayjs } from 'dayjs';

export enum OptionLegType {
  SHORT_PUT = 'SHORT_PUT',
  SHORT_CALL = 'SHORT_CALL',
  LONG_PUT = 'LONG_PUT',
  LONG_CALL = 'LONG_CALL',
}

export interface ModelParameters {
  riskFreeRate: number;
  volatility?: number;
  lookback: number;
  baseDate?: number;
}

export interface OptionLeg {
  legType: OptionLegType;
  strikePrice: number;
  premium: number;
  shares: number;
  premiumSelectedDate: Dayjs | null;
  daysToExpiration: number;
}

export interface TableData {
  tte: number;
  strikePrices: { [strike: number]: number };
  d50Price?: number;
}

export interface VolatilityDataRow {
  strike: number;
  value: number;
}

export interface ProfitLossData {
  price: number;
  profit: number;
  profitBounds: number[];
  volatility?: number;
}

export interface ProfitLossWithDomain {
  profitLossData: ProfitLossData[];
  domain: number[];
}

export interface TimeframeBoundsPoint {
  daysToExpiry: number;
  expirationDate: number;
  'bounds-timeframe': [number, number];
}
